// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Guidelines-Pagination-Pagination-module__currentItems";
var _2 = "webpack-concepts-Guidelines-Pagination-Pagination-module__pagination";
export { _1 as "currentItems", _2 as "pagination" }
